import {Link} from "react-router-dom";
import logo from "../image/atman fish banner.png";
import MenuItems from "./menuItems";
import React from "react";

export default function HeaderBar(){
    let toTop = function(){
        document.documentElement.scroll(0, 0);
    };

    return (
        <nav className="navbar navbar-expand-lg fixed-top navbar-transparent " color-on-scroll="300" >
            <div className="container">
                <div className="navbar-translate">
                    <Link to="/" className="navbar-brand" href="#" rel="tooltip" data-placement="bottom" onClick={toTop}>
                        <img src={logo} className="imageLogo-xs-vh"/>
                        <span style={{
                            "fontSize": "2vh",
                            "verticalAlign": "text-top",
                            "color": "#abc335",
                        }}>Chuang Xing</span>
                        {/*<img src={bigLogo} className="imageLogo-m"/>*/}
                    </Link>
                    <button className="navbar-toggler navbar-toggler" type="button" data-toggle="collapse"
                            data-target="#navigation" aria-controls="navigation-index" aria-expanded="false"
                            aria-label="Toggle navigation">
                        <span className="navbar-toggler-bar bar1"></span>
                        <span className="navbar-toggler-bar bar2"></span>
                        <span className="navbar-toggler-bar bar3"></span>
                    </button>
                </div>
                <div className="collapse navbar-collapse justify-content-end" id="navigation">
                    <MenuItems/>
                </div>
            </div>
        </nav>
    );
}